import { Navigate, useRoutes } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
// layouts
import DashboardLayout from "./layouts/dashboard";
import LogoOnlyLayout from "./layouts/LogoOnlyLayout";
//
import Login from "./pages/Login";
import Register from "./pages/Register";
import EditPostDocPage from "./pages/EditPostDoc/components/EditMainPage";
import RegisterPostDocPage from "./pages/RegisterPostDoc/components/RegisterMainPage";
import RegisterPhdPage from "./pages/RegisterPhD/components/RegisterMainPage";
import RegisterMentor from "./pages/RegisterMentor/components/RegisterMainPage/RegisterMentor";
import Profile from "./pages/Profile";
import Member from "./pages/Member";
import Extension from "./pages/Extension";
import NotFound from "./pages/Page404";
import Resubmit from "./pages/Resubmit";
import RenewalFellowship from "./pages/RenewalFellowship";
import ProgressReportApprovalAdmin from "./pages/ProgressReportApprovalAdmin";
import MedicalInsurance from "./pages/MedicalInsurance";
import ResearcherCard from "./pages/ResearcherCard";
import VisaExtension from "./pages/VisaExtension";
import ProfilePostDoc from "./pages/ProfilePostDoc";
import AnotherProfile from "./pages/AnotherProfile";
import ResearchProgress from "./pages/ResearchProgress";
import ApproveResearch from "./pages/ApproveResearch";
import Checked from "./pages/Checked";
import ExtensionSTD from "./pages/ExtensionSTD";
import RequestExtensionPostDoc from "./pages/Renewal_RequestExtension_PostDoc/RequestExtensionPostDoc";
import RenewalPostDoc from "./pages/Renewal_RequestExtension_PostDoc/RenewalPostDoc";
import FormForMaking from "./pages/Renewal_RequestExtension_PostDoc/Form/FormForMaking";
import FormVisaExtension from "./pages/Renewal_RequestExtension_PostDoc/Form/FormVisaExtension";
import FormMedicalInsurance from "./pages/Renewal_RequestExtension_PostDoc/Form/MedicalInsurance";
import ProfileLayout from "./layouts/ProfileLayout";

// import OutputSubmission from "./pages/OutputSubmission";
import OutputSubmission from "./pages/OutputSubmission/OutputSubmission";
import UploadFormPhD from "./pages/ResearchProgressUploadFormPhD/UploadFormPhD";
import UploadFormPostDoc from "./pages/ResearchProgressUploadFormPostDoc/UploadFormPostDoc";
import EditPhDPage from "./pages/EditPhD/components/EditPhDMainPage/EditPhDPage";
import EditMentorPage from "./pages/EditMentor/components/EditMentorMainPage/EditMentorPage";

import { useEffect, useState } from "react";

// ----------------------------------------------------------------------

export default function Router() {
  const { role } = useSelector((state) => state.authReducer);
  const { user, isClickAnotherProfile } = useSelector(
    (state) => state.userProfileReducer
  );

  const nameMentor = `${user?.personal_infomation.title_name_en}${
    user?.personal_infomation.name_en
  }${user?.personal_infomation.middle_en || ""}${
    user?.personal_infomation.surname_en
  }`;

  return useRoutes([
    {
      // path: "/member",
      element: <DashboardLayout />,
      children: [
        // { element: <Navigate to="/member" replace /> },

        // admin
        { path: `members/admin`, element: <Member /> },
        {
          path: `progress-report-approval/admin`,
          element: <ProgressReportApprovalAdmin />,
        },
        { path: `extension/admin`, element: <Extension /> },
        { path: `resubmit/admin`, element: <Resubmit /> },
        { path: `renewal-fellowship/admin`, element: <RenewalFellowship /> },
        {
          path: `medical-insurance/admin`,
          element: <MedicalInsurance />,
        },
        { path: `researcher-card/admin`, element: <ResearcherCard /> },
        { path: `visa-extension/admin`, element: <VisaExtension /> },

        // Mentor
        { path: `approve/mentor`, element: <ApproveResearch /> },
        { path: `extension/mentor`, element: <Extension /> },
        { path: `checked/mentor`, element: <Checked /> },
        { path: `renewal-fellowship/mentor`, element: <RenewalFellowship /> },

        // Postdoc
        { path: `research-progress/post_doc`, element: <ResearchProgress /> },
        { path: `extension-std/post_doc`, element: <ExtensionSTD /> },
        { path: `renewal-std/post_doc`, element: <RenewalPostDoc /> },

        // PhD 3 year
        { path: `research-progress/phd_3y`, element: <ResearchProgress /> },
        { path: `extension-std/phd_3y`, element: <ExtensionSTD /> },
        { path: `output-submission/phd_3y`, element: <OutputSubmission /> },

        // PhD 5 year
        { path: `research-progress/phd_5y`, element: <ResearchProgress /> },
        { path: `extension-std/phd_5y`, element: <ExtensionSTD /> },
        { path: `output-submission/phd_5y`, element: <OutputSubmission /> },

        // Other

        // Profile
        {
          path: "/profile",
          element: <ProfileLayout />,
          children: [
            { path: "admin", element: <Profile /> },
            { path: "mentor", element: <Profile /> },
            { path: "post_doc", element: <ProfilePostDoc /> },
            { path: "phd_3y", element: <Profile /> },
            { path: "phd_5y", element: <Profile /> },
            { path: "phd/edit", element: <EditPhDPage /> },
            { path: "post_doc/edit", element: <EditPostDocPage /> },
            { path: "mentor/edit", element: <EditMentorPage /> },
          ],
        },
        isClickAnotherProfile === true && {
          path: `/anotherProfile/${user?.role?.role}/${
            user?.personal_infomation?.student_id || nameMentor
          }`,
          element: <AnotherProfile />,
        },

        // Request Extension
        {
          path: "request-extension/post_doc",
          element: <RequestExtensionPostDoc />,
        },
        {
          path: "request-extension/phd_3y",
          element: <RequestExtensionPostDoc />,
        },
        {
          path: "request-extension/phd_5y",
          element: <RequestExtensionPostDoc />,
        },

        // Upload Form
        { path: "upload-formPhd-3y/phd_3y", element: <UploadFormPhD /> },
        { path: "upload-formPhd-5y/phd_5y", element: <UploadFormPhD /> },
        { path: "upload-formPostDoc/post_doc", element: <UploadFormPostDoc /> },
        { path: "form-making/post_doc", element: <FormForMaking /> },
        {
          path: "form-visa-extension/post_doc",
          element: <FormVisaExtension />,
        },
        {
          path: "medical-insurance/post_doc",
          element: <FormMedicalInsurance />,
        },
      ],
    },
    {
      path: "/",
      element: <LogoOnlyLayout />,
      children: [
        { path: "login", element: <Login /> },
        { path: "register", element: <Register /> },
        { path: "404", element: <NotFound /> },
        { path: "/", element: <Login /> },
        isClickAnotherProfile === false && {
          path: "*",
          element: <Navigate to="/404" />,
        },
      ],
    },
    {
      path: "/register",
      element: <LogoOnlyLayout />,
      children: [
        { element: <Navigate to="/register" replace /> },
        { path: `post-doc`, element: <RegisterPostDocPage /> },
        { path: `phd`, element: <RegisterPhdPage /> },
        { path: `mentor`, element: <RegisterMentor /> },
      ],
    },
    isClickAnotherProfile === false && {
      path: "*",
      element: <Navigate to="/404" replace />,
    },
  ]);
}
